// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import '@/styles/base.css'
import '@/styles/index.less'
import '@/styles/indexNew.less'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import axios from './util/axios'
import httpCode from './util/httpCode'
import api from './api/all'
import uploader from 'vue-simple-uploader'
import * as echarts from 'echarts'
import i18n from './i18n/index'
import locale from 'element-ui/lib/locale/lang/en'
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
import './styles/iconfont/iconfont.css'

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue
  .use(ElementUI, { locale })
  .use(axios)
  .use(httpCode)
  .use(api)
  .use(uploader)
  .use(VueDirectiveImagePreviewer)


//为window全局添加一些组件
window.$loading = ElementUI.Loading;

const has = Vue.directive('has', {
  inserted: function (el, binding) {
    // 获取按钮权限
    if (!Vue.prototype.$_has(binding.value)) {
      el.parentNode.removeChild(el)
    }
  }
})
Vue.prototype.$_has = function (value) {
  let isExit = false
  let buttonPermsStr = sessionStorage.getItem('buttonpermissions').split(",")
  if (buttonPermsStr === undefined || buttonPermsStr === null) {
    return false
  }
  for (let i = 0; i < buttonPermsStr.length; i++) {
    if (value === buttonPermsStr[i]) {
      isExit = true
      break
    }
  }
  return isExit
}
export {has}




/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js